import React, { useEffect } from 'react'
import Event from './eventImg/event-25-july.webp'


const Event16 = () => {
    useEffect(() => {
        document.title = "ISHRAE Knowledge Talk on Latest design trends in Switchgear & Controlgear technology & a brief overview of IEC standards for Panels";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>25 July 2025</h1> 
<h3 className='text-center'>ISHRAE Knowledge Talk on Latest design trends in Switchgear & Controlgear technology & a brief overview of IEC standards for Panels</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='ISHRAE Knowledge Talk on Latest design trends in Switchgear & Controlgear technology & a brief overview of IEC standards for Panels'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/OOl1R72xWHU=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event16

